import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import { Banner } from '~/components/Molecules/Banner'
import { Header } from '~/components/Molecules/Header'
import { Table } from '~/components/Organisms/Table'

import { useStats } from '~/lib/stats'

export function Report() {
  const { data, isLoading } = useStats()
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      gap={theme.spacing['4XL']}
      bgcolor={theme.palette.common.white}
      padding={`${theme.spacing.XXL} ${theme.spacing['4XL']}`}
      sx={{ marginTop: theme.spacing.M, borderTopLeftRadius: theme.radius.XL }}
    >
      <Header title={t('common:reports')} />
      <Box display="flex" flexDirection="column" gap={theme.spacing.XXL}>
        <Banner data={data} />
        <Table data={data} isLoading={isLoading} />
      </Box>
    </Box>
  )
}
